export enum TokenCategoryType {
    Common = 1,
    Admin = 2,
    Broker = 3,
    Borrower = 4,
    Notices = 5,
    UserAgreement = 6,
}
